import ClearFilters from './clearFilters';

const clearButton = document.querySelector('[data-advanced-clear-filters]');
const clearFilters = new ClearFilters(clearButton);

/**
 * toggle the visibility of the clear all button
 * it should be less visible when no filters are applied, and more visible when filters are applied
 * @param {Array} appliedFacets List of applied facets.
 */
const toggleClearAllButton = (appliedFacets) => {
  if (appliedFacets.length > 0) {
    clearButton.removeAttribute('disabled');
  } else {
    clearButton.setAttribute('disabled', '');
  }
};

// subscribe to the observable and call the toggleClearAllButton function
clearFilters.onFacetsApplied$.subscribe(toggleClearAllButton);
